import React from "react";

function AboutMe() {
  return (
    <div className="my-5 p-3 rounded-md border border-solid shadow-md hover:border-green-300">
      <h1 className="text-4xl font-bold mb-2">About me</h1>
      <div className="my-2">
        <h2 className="text-2xl font-semibold">학력</h2>
        <ul>
          <li>강원대학교 컴퓨터공학부 졸업 (23.02)</li>
          <li>울산 호계고등학교 졸업 (14.02)</li>
        </ul>
      </div>

      <div className="my-2">
        <h2 className="text-2xl font-semibold">자격증</h2>
        <ul>
          <li>정보처리기사 (23.09)</li>
          <li>컴퓨터활용 1급 (20.05)</li>
        </ul>
      </div>
    </div>
  );
}

export default AboutMe;
